import { ToastContainer } from 'react-toastify';
import { useSelector } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { router } from './router';
import type { RootState } from './redux/store';
import { persistor } from './redux/store';
import { LoadingScreen } from './screens/LoadingScreen';
import { useInactivityLogout } from './hooks/useInactivityLogout.hook';
import 'react-toastify/dist/ReactToastify.css';

import { rehydrateAuthState } from './redux/slices/authReducer.slice';
function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(rehydrateAuthState());
  }, [dispatch]);

  return (
    <div className="App">
      <ToastContainer />
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
          <InactivityLogoutWrapper />
          <RouterProvider router={router} />
        </GoogleOAuthProvider>
      </PersistGate>
    </div>
  );
}

const InactivityLogoutWrapper = () => {
  const isAuthenticated = useSelector((state: RootState) => state.authReducer.isAuthenticated);

  useInactivityLogout(isAuthenticated);
  return null;
};

export default App;
